import type { Toasts } from "../state/useToasts";

export function ToastHost({ toasts, dismiss }: Pick<Toasts, "toasts" | "dismiss">) {
  return (
    <div className="toast-host" role="region" aria-label="Notifications">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast ${toast.tone}`}
          role={toast.tone === "error" ? "alert" : "status"}
        >
          <div className="toast-body">
            <div>{toast.message}</div>
            {toast.details.length > 0 && (
              <ul className="toast-details">
                {toast.details.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
            )}
          </div>
          {toast.action !== undefined && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                toast.action?.run();
                dismiss(toast.id);
              }}
            >
              {toast.action.label}
            </button>
          )}
          <button
            type="button"
            className="icon-button"
            aria-label="Dismiss notification"
            onClick={() => dismiss(toast.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
